export default {"src":"/pages/_next/static/media/top50-content-management.719724b7.svg","height":115,"width":102,"blurWidth":0,"blurHeight":0};